import PropTypes from 'prop-types'
import React, { Component } from 'react'
import IconSVG from 'svg-inline-react'
import { OrderedSet } from 'immutable'
import classnames from 'classnames'
import { makeDefaultFailedContainer } from 'components/container'
import { isEmail } from 'validator'
import Input from 'shared-web/src/components/Input'
import Modal from 'components/Modal'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { actions as TrackingActions } from 'app/modules/tracking'

import styles from './styles.styl'

const EMAIL_SNIPPET =
  'Hello! Do you mind helping me install Drift on our website? It shouldn’t take more than 2 minutes. The code snippet is below and here are some instructions.\n\n[Drift code will appear here]'

class EmailInviteModal extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  }

  state = {
    inputValue: '',
  }

  handleSubmit = e => {
    e.preventDefault()
    const { inputValue } = this.state
    this.app.actions.OrgActions.shareSnippet(inputValue, this.props.org.id)
    this.props.onClose()
    this.props.actions.track('Onboarding Install Assistance Request Email Sent', {
      context: 'widget-onboarding',
    })
    if (!this.props.skipRedirect) {
      this.context.router.push('/')
    }
    this.props.onSend()
  }

  handleChange = event => {
    const globalHandle = event.target.value.trim()
    this.setState({
      inputValue: globalHandle,
    })
  }

  render() {
    const { inputValue } = this.state
    const { users, onClose } = this.props
    const isValid = this.state.inputValue && isEmail(this.state.inputValue)

    return (
      <Modal ignoreCloseOnClickOutside onClose={onClose} modalContentClassName="snippet-share-modal">
        <div className="snippet-share-header">Email a teammate</div>
        <form className="drift-form" onSubmit={this.handleSubmit}>
          <fieldset>
            <label>
              Send To
              <input
                autoFocus={true}
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$"
                type="email"
                value={inputValue}
                placeholder="Enter an email address"
                onChange={this.handleChange}
                className={classnames('valid-email', isValid)}
              />
            </label>
          </fieldset>
          <fieldset>
            <label>
              Message
              <textarea className="email-message" readOnly rows="6" cols="40">
                {EMAIL_SNIPPET}
              </textarea>
            </label>
          </fieldset>
          <button disabled={!isValid} className="drift-button drift-button-primary">
            Send Message
          </button>
        </form>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        track: TrackingActions.track,
      },
      dispatch
    ),
  }
}

const EmailInviteModalContainer = makeDefaultFailedContainer(EmailInviteModal, {
  listenTo: ['stores.OrgStore', 'stores.UserStore'],
  fetch: {
    org() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg()
    },
    users() {
      return this.app.stores.UserStore.getOrFetchUsersForCurrentUserOrg()
    },
  },
})

const EmailInviteModalConnect = connect(
  null,
  mapDispatchToProps
)(EmailInviteModalContainer)

export default EmailInviteModalConnect



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/EmailInviteModal.js